import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class CounterpartiesApi extends ApiModule {
	constructor() {
		super(ModulesMap.COUNTERPARTIES, {
			entity: 'counterparties',
		})
	}
}
